import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoaderComponentProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
  /** If true, renders as a fixed full-screen overlay that blocks interaction */
  overlay?: boolean;
  /** If true, renders as an absolute overlay within a relative parent */
  inlineOverlay?: boolean;
}

const LoaderComponent: React.FC<LoaderComponentProps> = ({ 
  size = 'md', 
  text, 
  className = '',
  overlay = false,
  inlineOverlay = false,
}) => {
  const iconSize = {
    sm: 'h-5 w-5',
    md: 'h-8 w-8',
    lg: 'h-10 w-10',
  };

  const containerPadding = {
    sm: 'py-4',
    md: 'py-8',
    lg: 'py-12',
  };

  if (overlay) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/60 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-3 bg-card p-6 rounded-lg shadow-lg border">
          <Loader2 className={cn("animate-spin text-primary", iconSize[size])} />
          {text && <p className="text-sm font-medium text-foreground">{text}</p>}
        </div>
      </div>
    );
  }

  if (inlineOverlay) {
    return (
      <div className="absolute inset-0 bg-background/50 backdrop-blur-sm z-10 flex justify-center items-center rounded-lg">
        <div className="flex items-center gap-2 bg-background border rounded-lg px-4 py-2 shadow-lg">
          <Loader2 className={cn("animate-spin text-primary", iconSize['sm'])} />
          {text && <span className="text-sm font-medium text-foreground">{text}</span>}
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center justify-center gap-2", containerPadding[size], className)}>
      <Loader2 className={cn("animate-spin text-primary", iconSize[size])} />
      {text && <p className="text-sm font-medium text-muted-foreground">{text}</p>}
    </div>
  );
};

export default LoaderComponent;
